import React, { useState, useContext, useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import HeaderBar from 'components/HeaderBar/HeaderBar'
import Button from 'components/common/Button'
import SearchInput from '../../Components/SearchInput/SearchInput'
import Tags from '../../Components/Tags/Tags'
import GuestGroupsList from './GuestGroupsList/GuestGroupsList'
import NoticeRed from 'assets/icons/ico-notice-red.png'
import ActionSheet from 'components/common/ActionSheet/ActionSheet'
import PopConfirm from 'components/common/PopConfirm/PopConfirm'
import EditModal from '../../Components/EditModal/EditModal'
import { PHONE_NUMBER_CONTACT_METHOD, HOBNOB_USER_CONTACT_METHOD } from 'services/contact_methods'
import compWithGuestEditModal from '../HOC/WithGuestEditModal'
import { hasUserAccessToken } from 'services/access_tokens'
import { POPUP_BOX_TYPES_CONSTANTS } from 'src/constants'
import PageContainerContext from 'services/contexts'
import { deepCopyObject, isEmptyString } from 'services/utils'
import LoadingComponent from 'src/components/common/LoadingComponent/LoadingComponent'
import DMChat from './DMChat/DMChat'
import { switchChatUser } from 'src/actions/eventChat'
import RSVPByHostModalContainer from 'src/components/rsvp-by-host-modal/RSVPByHostModalContainer'

import styles from './guests-list-page-mobile.scss'
import { listAllOrdersForEventRequest } from '../../../../../../../actions/paymentGraphql'
import SelfUpdateRsvpActionSheet from './SelfUpdateRsvpActionSheet/SelfUpdateRsvpActionSheet'
import { routerActions } from 'react-router-redux'
import { showRsvpModal, updateChangeRsvpStatus, showHud } from 'src/actions/frontend'
import { showLogin } from 'src/actions/login'

const EditModalHOC = compWithGuestEditModal(EditModal)

const GuestsListPageMobile = ({
  userId,
  isHost,
  isHostOrCohost,
  selectedGuest,
  event,
  users,
  searchValue,
  selectedTag,
  searchGuestsList,
  tags,
  onSelectGuest,
  onGetGuestsList,
  onSelectTag,
  onInputChange,
  onRemoveGuest,
  onEditGuest,
  onChangeEventsModal,
  onSendInvitations,
  ticketTypes,
  eventTicketCounts,
  needPayTicket
}) => {
  const dispatch = useDispatch()
  const [isOpenActionSheet, setIsOpenActionSheet] = useState(false)
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)
  const [actionSheetData, setActionSheetData] = useState([])
  const { onChangePopupBox, onChangePopupBoxCallBack } = useContext(PageContainerContext)
  const editModalRef = useRef(null)
  const failedCount = onGetGuestsList('failed').length
  const unSentCount = onGetGuestsList('unsent').length
  const createdCount = onGetGuestsList('created').length
  const isCreating = createdCount !== unSentCount

  const [isRsvpByHostModalVisible, setIsRsvpByHostModalVisible] = useState(false)
  const [requestedRsvp, setRequestedRsvp] = useState('')
  const [isOpenRsvpActionSheet, setIsOpenRsvpActionSheet] = useState(false)
  const [listMyOrdersForEvent, setListMyOrdersForEvent] = useState([])
  const [changeRsvp, setChangeRsvp] = useState(false)
  const [isShowUpdateGuestCount, setIsShowUpdateGuestCount] = useState(false)
  const [currentInvitationTicketTypesCounts, setCurrentInvitationTicketTypesCounts] = useState([])
  const [ticketCounts, setTicketCounts] = useState([])
  const isHasUserAccessToken = hasUserAccessToken()

  const [isOpenSelfRsvpActionSheet, setIsOpenSelfRsvpActionSheet] = useState(false)

  useEffect(() => {
    let timeout = null
    timeout = setTimeout(() => {
      history.pushState(null, null, location.href)
      onChangePopupBox(POPUP_BOX_TYPES_CONSTANTS.guestsList)
      onChangePopupBoxCallBack(() => onChangeEventsModal('details'))
    }, 1000)

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
      onChangePopupBox(null)
      onChangePopupBoxCallBack(null)
    }
  }, [])

  const getUser = item => {
    const { guest, first_name, last_name, display_name } = item

    const hobnobUser = deepCopyObject(users[guest])
    const isHost = event.host === guest

    const user = hobnobUser || item

    if (isHost && !isEmptyString(event.custom_host_name)) {
      user.displayName = event.custom_host_name
    } else if (user.verified) {
      user.displayName = `${user.first_name || ''} ${user.last_name || ''}`
    } else if (!isEmptyString(first_name + last_name)) {
      user.displayName = `${first_name || ''} ${last_name || ''}`
    } else {
      user.displayName = display_name
    }

    return user
  }

  const generateActionData = checkedGuest => {
    const actionList = []

    const renderFullNameTag = () => {
      if (!checkedGuest) return null

      const user = users[checkedGuest.guest]
      if (user?.verified) return null
      return (
        <li key="contact" onClick={() => handleOpenEditModal(checkedGuest)}>
          edit contact
        </li>
      )
    }

    const renderCohostTag = () => {
      if (!checkedGuest) return null

      const { contact_method, cohost } = checkedGuest
      if (
        !isHost ||
        (contact_method.type !== PHONE_NUMBER_CONTACT_METHOD &&
          contact_method.type !== HOBNOB_USER_CONTACT_METHOD) ||
        (checkedGuest.delivery_state !== 'delivered' && checkedGuest.delivery_state !== 'viewed') ||
        event.host === checkedGuest.guest
      ) {
        return null
      }

      const style = cohost ? { color: '#d00218' } : { textTransform: 'initial' }
      const params = cohost ? { cohost: false } : { cohost: true }

      return (
        <li key="cohost" style={style} onClick={() => handleEditGuest(params)}>
          {cohost ? 'remove cohost' : 'Add as Cohost'}
        </li>
      )
    }

    const renderRemoveTag = () => {
      if (!checkedGuest) return null
      if (!isHostOrCohost) return null
      return (
        <li
          onClick={() => {
            setIsOpenRemoveModal(true)
            setIsOpenActionSheet(false)
          }}
          style={{ color: '#d00218' }}
          key="remove"
        >
          remove guest
        </li>
      )
    }

    const renderMessageTag = () => {
      if (!checkedGuest) return null
      const { contact_method, guest } = checkedGuest

      const isCanChat =
        (contact_method?.type === HOBNOB_USER_CONTACT_METHOD ||
          contact_method?.type === PHONE_NUMBER_CONTACT_METHOD) &&
        isHasUserAccessToken &&
        checkedGuest.guest !== userId

      if (isCanChat) {
        return (
          <li
            key="message"
            onClick={() => {
              const user = users[guest]
              dispatch(switchChatUser(user))
              setIsOpenActionSheet(false)
            }}
          >
            Send Message
          </li>
        )
      }

      return null
    }

    const _validateDate = () => {
      const { cutoff_date } = event
      if (cutoff_date) {
        return new Date() > new Date(cutoff_date)
      }
      return false
    }

    const renderUpdateRsvpAction = () => {
      if (!checkedGuest || !isHost || !isHasUserAccessToken) return null
      if (checkedGuest.delivery_state === 'queued') return null

      const isOutOfDate = _validateDate()

      const isCanUpdateRsvp =
        checkedGuest.delivery_state === 'delivered' || checkedGuest.delivery_state === 'viewed'

      const onClickUpdateRsvp = () => {
        if (checkedGuest.rsvp_state === 'undecided') {
          setIsOpenActionSheet(false)
          setChangeRsvp(false)
          setIsShowUpdateGuestCount(false)
          setIsOpenRsvpActionSheet(true)
        } else {
          setRequestedRsvp(checkedGuest.rsvp_state)
          setIsOpenActionSheet(false)
          setChangeRsvp(true)
          setIsShowUpdateGuestCount(false)
          setIsRsvpByHostModalVisible(true)
        }
      }

      const onClickUpdateGuestCount = () => {
        setIsOpenActionSheet(false)
        setChangeRsvp(false)
        setIsShowUpdateGuestCount(true)
        setIsRsvpByHostModalVisible(true)
      }

      if (isCanUpdateRsvp && !isOutOfDate && !needPayTicket) {
        const items = [
          <li key="update-rsvp" onClick={onClickUpdateRsvp}>
            Update RSVP
          </li>
        ]
        if (checkedGuest.rsvp_state === 'accepted' && event.guest_count_enabled) {
          items.push(
            <li key="update-guest-count" onClick={onClickUpdateGuestCount}>
              Update Guest Count
            </li>
          )
        }
        return items
      }
      return null
    }

    const renderSelfUpdateRsvpAction = () => {
      if (isHost || !checkedGuest || checkedGuest.guest !== userId || !isHasUserAccessToken) return null
      const isAnnouncement = event.event_type === 'announcement'

      const onClickUpdateRsvp = () => {
        if (checkedGuest.rsvp_state === 'undecided') {
          setIsOpenActionSheet(false)
          setIsOpenSelfRsvpActionSheet(true)
        } else {
          setIsOpenActionSheet(false)
          dispatch(routerActions.push('rsvp'))
          dispatch(showRsvpModal())
          dispatch(updateChangeRsvpStatus({ changeRsvp: true }))
        }
      }

      const onClickUpdateGuestCount = () => {
        setIsOpenActionSheet(false)
        dispatch(routerActions.push('rsvp'))
        dispatch(showRsvpModal())
        dispatch(updateChangeRsvpStatus({ changeRsvp: true }))
      }

      if (!isAnnouncement) {
        const items = [
          <li key="update-rsvp" onClick={onClickUpdateRsvp}>
            Update RSVP
          </li>
        ]
        if (checkedGuest.rsvp_state === 'accepted' && event.guest_count_enabled) {
          items.push(
            <li key="update-guest-count" onClick={onClickUpdateGuestCount}>
              Update Guest Count
            </li>
          )
        }
        return items
      }
      return null
    }

    const fullNameEl = renderFullNameTag()
    const cohostEl = renderCohostTag()
    const removeEl = renderRemoveTag()
    const messageEl = renderMessageTag()
    const updateRsvpEl = renderUpdateRsvpAction()
    const selfUpdateRsvpEl = renderSelfUpdateRsvpAction()

    if (fullNameEl) actionList.push(fullNameEl)
    if (cohostEl) actionList.push(cohostEl)
    if (messageEl) actionList.push(messageEl)
    if (updateRsvpEl) actionList.push(updateRsvpEl)
    if (selfUpdateRsvpEl) actionList.push(selfUpdateRsvpEl)
    if (removeEl) actionList.push(removeEl)

    return actionList
  }

  const renderButton = () => {
    if (!isHostOrCohost || !isHasUserAccessToken) return null

    const isHaveUnsent = unSentCount > 0

    return (
      <div className={styles['button-wrapper']}>
        <Button
          className={styles['button-inner']}
          onClick={() => {
            window.mixpanel.track('ADD GUESTS Clicked', { event_id: event.id, user_id: userId })
            onChangeEventsModal('addGuests')
          }}
          plain={isHaveUnsent}
        >
          add guests
        </Button>

        {isHaveUnsent && (
          <Button
            disabled={isCreating}
            className={styles['button-inner']}
            onClick={onSendInvitations}
          >
            {isCreating ? `${createdCount}/${unSentCount} CREATED` : `SEND ${unSentCount} INVITES`}
          </Button>
        )}
      </div>
    )
  }

  const handleOpenEditModal = (checkedGuest) => {
    editModalRef.current.openModal(checkedGuest)
    setIsOpenActionSheet(false)
  }

  const handleEditGuest = params => {
    onEditGuest(params)
    setIsOpenActionSheet(false)
  }

  const handleRemoveGuest = () => {
    onRemoveGuest()
    setIsOpenRemoveModal(false)
  }

  const handleClickGuest = guest => {
    if (!hasUserAccessToken()) {
      dispatch(showLogin())
      return
    }

    if (guest.guest !== event.host) {
      onSelectGuest(guest)
      const data = generateActionData(guest)

      if (isHostOrCohost && isHasUserAccessToken) {
        dispatch(
          listAllOrdersForEventRequest(
            event.id,
            guest.id,
            {},
            {
              onSuccessCallback: response => {
                const orders = response?.data?.list_all_orders_for_event?.orders || []
                setListMyOrdersForEvent(orders)
              }
            }
          )
        )

        const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)

        const { child_count_enabled, guest_count_enabled } = event

        const invitationTicketCounts = eventTicketCounts.invitations.find(invitation => invitation.id === guest.id)?.ticket_counts || []

        const ticketCounts = []

        const firstAdult = activeTicketTypes.find(ticketType => ticketType.label === 'adult')
        if (firstAdult) {
          let count = 1

          if (guest_count_enabled) {
            count = invitationTicketCounts.find(tc => tc.ticket_type_id === firstAdult.id)?.ticket_count || 1
          }

          ticketCounts.push({
            id: firstAdult.id,
            label: firstAdult.label,
            count
          })
        }

        if (child_count_enabled) {
          const firstChild = activeTicketTypes.find(ticketType => ticketType.label === 'child')
          if (firstChild) {
            const count = invitationTicketCounts.find(tc => tc.ticket_type_id === firstChild.id)?.ticket_count || 0
            ticketCounts.push({
              id: firstChild.id,
              label: firstChild.label,
              count
            })
          }
        }

        setCurrentInvitationTicketTypesCounts(ticketCounts)
        setTicketCounts(ticketCounts)
      }

      if (data.length > 0) {
        setActionSheetData(data)
        setIsOpenActionSheet(true)
      }
    }
  }

  const handleCloseRsvpByHostModal = () => {
    setIsRsvpByHostModalVisible(false)
    setChangeRsvp(false)
    setIsShowUpdateGuestCount(false)
    setRequestedRsvp('')
    setListMyOrdersForEvent([])
    setCurrentInvitationTicketTypesCounts([])
  }

  const handleSaveRsvpByHostModal = ({ rsvpState, ticketCounts }) => {
    onEditGuest({
      rsvpState: rsvpState,
      ticketCounts: ticketCounts
    })
    handleCloseRsvpByHostModal()
  }

  const _onDeclineInvitationForAccepted = () => {
    setRequestedRsvp('declined')
    onEditGuest({
      rsvpState: 'declined',
      ticketCounts: ticketCounts
    })
    handleCloseRsvpByHostModal()
  }

  const _onInputTicketCountsChange = (ticketCountId, newValue) => {
    setTicketCounts(prevState => {
      const updatedTicketCounts = prevState.map(tc => {
        if (tc.id === ticketCountId) {
          return { ...tc, count: newValue }
        }
        return tc
      })
      return updatedTicketCounts
    })
  }

  const onNotAttendingClick = () => {
    setIsOpenRsvpActionSheet(false)
    _onDeclineInvitationForAccepted()
  }

  const _verifyInvitationGuest = () => {
    const { max_capacity, limit_per_invitation } = event

    const guestId = selectedGuest.id

    const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)
    const activeTypeIds = activeTicketTypes.map(item => item.id)

    const otherAcceptedInvitations = eventTicketCounts.invitations.filter(invitation => invitation.rsvp_state === 'accepted' && invitation.id !== guestId)

    const otherGuest = otherAcceptedInvitations.reduce((sum, invitation) => {
      const invitationTicketCounts = invitation.ticket_counts.filter(tc => {
        return activeTypeIds.includes(tc.ticket_type_id)
      })
      const invitationTotal = invitationTicketCounts.reduce((acc, ticket) => acc + ticket.ticket_count, 0)
      return sum + invitationTotal
    }, 0)

    const totalTickets = ticketCounts.reduce((acc, ticket) => ticket.count + acc, 0)

    if (limit_per_invitation !== 9999 && totalTickets > limit_per_invitation) {
      dispatch(
        showHud('error', `This Event allows a maximum of ${limit_per_invitation} Guest(s) per invitation`)
      )
      return false
    }

    if (max_capacity !== 9999 && totalTickets + otherGuest > max_capacity) {
      dispatch(
        showHud('error', `Your RSVP exceeds the event's maximum capacity`)
      )
      return false
    }

    return true
  }

  const onAttendingClick = () => {
    const { guest_count_enabled } = event
    if (guest_count_enabled) {
      setRequestedRsvp('accepted')
      setChangeRsvp(false)
      setIsRsvpByHostModalVisible(true)
    } else {
      if (_verifyInvitationGuest()) {
        onEditGuest({
          rsvpState: 'accepted',
          ticketCounts: ticketCounts
        })
      }
    }
    setIsOpenRsvpActionSheet(false)
  }

  const displayName = getUser(selectedGuest || {}).displayName

  const guestList = searchValue ? searchGuestsList : onGetGuestsList()

  return (
    <div className={styles['guests-list-mobile-container']}>
      <HeaderBar backIcon>
        <div className={styles['header-title']}>
          <span className={styles['title']}>guest list</span>
          <span className={styles['subtitle']}>{event.name}</span>
        </div>
      </HeaderBar>

      {isCreating ? (
        <div className={styles['loading-container']}>
          <LoadingComponent light type="partial" />
        </div>
      ) : (
        <div className={styles['content-container']}>
          <SearchInput value={searchValue} onChange={onInputChange} />

          {failedCount > 0 && (
            <div className={styles['failed-text']}>
              <img src={NoticeRed} width="14" />
              You have {failedCount} failed invites!
            </div>
          )}
          <Tags
            tagsList={tags}
            selectedTag={selectedTag}
            onSelectTag={onSelectTag}
            onGetGuestsList={onGetGuestsList}
          />

          <GuestGroupsList
            guestsList={guestList}
            onClickGuest={handleClickGuest}
            onGetUser={getUser}
          />
        </div>
      )}

      {renderButton()}

      <ActionSheet
        visible={isOpenActionSheet}
        onClose={() => setIsOpenActionSheet(false)}
        headerNode={
          <div className={styles['action-sheet-header']}>
            <span className={styles['title']}>{displayName}</span>
            <span className={styles['subtitle']}>{selectedGuest?.contact_method_display_name}</span>
          </div>
        }
      >
        <ul>{actionSheetData.map(item => item)}</ul>
      </ActionSheet>

      <ActionSheet
        visible={isOpenRsvpActionSheet}
        onClose={() => setIsOpenRsvpActionSheet(false)}
        headerNode={
          <div className={styles['action-sheet-header']}>
            <span className={styles['title']}>Update {displayName}‘s RSVP</span>
          </div>
        }
      >
        <ul>
          <li
            onClick={onAttendingClick}
          >
            Attending
          </li>
          <li
            onClick={onNotAttendingClick}
          >
            Not Attending
          </li>
        </ul>
      </ActionSheet>

      <SelfUpdateRsvpActionSheet
        isOpenRsvpActionSheet={isOpenSelfRsvpActionSheet}
        onClose={() => setIsOpenSelfRsvpActionSheet(false)}
        headerNode={
          <div className={styles['action-sheet-header']}>
            <span className={styles['title']}>RSVP</span>
          </div>
        }
      />

      <DMChat />

      <PopConfirm
        visible={isOpenRemoveModal}
        onClose={() => setIsOpenRemoveModal(false)}
        onConfirm={handleRemoveGuest}
        confirmText="remove"
        type="delete"
      >
        Are you sure you want to remove “{displayName}” from your guest list?
      </PopConfirm>

      <EditModalHOC
        ref={editModalRef}
        isHost={isHost}
        event={event}
        isHostOrCohost={isHostOrCohost}
        onEditGuest={handleEditGuest}
        selectedGuest={selectedGuest}
        eventTicketCounts={eventTicketCounts}
        ticketTypes={ticketTypes}
        needPayTicket={needPayTicket}
      />

      {
        isRsvpByHostModalVisible && (
          <RSVPByHostModalContainer
            event={event}
            invitation={selectedGuest}
            changeRsvp={changeRsvp}
            showUpdateGuestCount={isShowUpdateGuestCount}
            visible={isRsvpByHostModalVisible}
            onClose={handleCloseRsvpByHostModal}
            onSave={handleSaveRsvpByHostModal}
            requestedRsvp={requestedRsvp}
            onSetRequestedRsvp={setRequestedRsvp}
            listMyOrdersForEvent={listMyOrdersForEvent}
            ticketTypes={ticketTypes}
            ticketTypesCounts={currentInvitationTicketTypesCounts}
            eventTicketCounts={eventTicketCounts}
            ticketCounts={ticketCounts}
            onInputTicketCountsChange={_onInputTicketCountsChange}
            displayName={displayName}
          />

        )
      }

    </div>
  )
}

GuestsListPageMobile.propTypes = {
  userId: PropTypes.string,
  isHost: PropTypes.bool,
  isHostOrCohost: PropTypes.bool,
  selectedGuest: PropTypes.object,
  event: PropTypes.object,
  users: PropTypes.object,
  searchValue: PropTypes.string,
  selectedTag: PropTypes.string,
  searchGuestsList: PropTypes.array,
  tags: PropTypes.array,
  onSelectGuest: PropTypes.func,
  onGetGuestsList: PropTypes.func,
  onSelectTag: PropTypes.func,
  onInputChange: PropTypes.func,
  onRemoveGuest: PropTypes.func,
  onEditGuest: PropTypes.func,
  onChangeEventsModal: PropTypes.func,
  onSendInvitations: PropTypes.func,
  eventTicketCounts: PropTypes.object || null,
  ticketTypes: PropTypes.array,
  needPayTicket: PropTypes.bool
}

export default GuestsListPageMobile
